import { TextFieldTypes } from "@swiggy-private/dls-web-core/dist/components/TextField/types";

import { ORDER_TYPE_BOTTOM_SHEET_COPY } from "../order-type-preference-options/constants";
import { ON_PREMISE_MOBILE_MAX_DIGITS } from "./helpers";

export const ON_PREMISE_MOBILE_TEXT_FIELD_NAME = "on-premise-mobile";

export const ON_PREMISE_MOBILE_TEXT_FIELD_DETAILS = {
    label: ORDER_TYPE_BOTTOM_SHEET_COPY.MOBILE_LABEL,
    name: ON_PREMISE_MOBILE_TEXT_FIELD_NAME,
    type: TextFieldTypes.PHONE,
    attrs: {
        placeholder: "",
        inputMode: "numeric" as const,
        maxLength: ON_PREMISE_MOBILE_MAX_DIGITS,
        autoComplete: "tel",
    },
};
